import type { ComponentPartWithStates } from '@wix/editor-elements-panel/src/adapters/types';
import { TranslationKeys } from '../../../constants';
import {
  DISABLED_STATE,
  HOVER_STATE,
  REGULAR_STATE,
  sectionsPropertyKeys,
} from '@wix/editor-elements-panel';

export enum PaginationParts {
  Page = 'page',
  NavigationButton = 'navigation-button',
}

export const paginationComponentParts: Array<ComponentPartWithStates> = [
  {
    id: PaginationParts.Page,
    label: TranslationKeys.designCurrentPageLabel,
    states: [REGULAR_STATE.id],
    defaultState: REGULAR_STATE.id,
  },
  {
    id: PaginationParts.NavigationButton,
    label: TranslationKeys.designNavigationButtonsLabel,
    states: [REGULAR_STATE.id, HOVER_STATE.id, DISABLED_STATE.id],
    defaultState: REGULAR_STATE.id,
  },
];

const commonPropertyKeys = {
  background: 'background',
  border: sectionsPropertyKeys.border,
  corner: sectionsPropertyKeys.corner,
  text: {
    regular: {
      font: 'font',
      color: 'color',
      letterSpacing: 'letter-spacing',
      textDecoration: 'text-decoration',
      textHighlight: 'text-highlight',
      textOutline: 'text-outline',
      textShadow: 'text-shadow',
    },
    hover: {
      color: 'color',
      textDecoration: 'text-decoration',
      textHighlight: 'text-highlight',
      textOutline: 'text-outline',
    },
  },
  icon: {
    regular: {
      iconSize: 'icon-size',
      iconColor: 'icon-color',
    },
    hover: {
      iconColor: 'icon-color',
    },
  },
};

export const propertyKeys = {
  common: { ...commonPropertyKeys },
  button: {
    ...commonPropertyKeys,
    text: {
      regular: {
        ...commonPropertyKeys.text.regular,
        textTransform: 'text-transform',
      },
      hover: {
        ...commonPropertyKeys.text.hover,
        textTransform: 'text-transform',
      },
    },
  },
};
